import { asyncLoadScript } from '../helpers'

/* eslint-disable */
export function initGoogleAnalytics() {
	(function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){
		(i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),
		m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)
		})(window,document,'script','https://www.google-analytics.com/analytics.js','ga');
}

window.dataLayer = window.dataLayer || [];
window.gtag = function(){ dataLayer.push(arguments); }

export function initGoogleTagManager(measurementId) {
	asyncLoadScript(`https://www.googletagmanager.com/gtag/js?id=${measurementId}`);
}
/* eslint-enable */